import React from 'react'

import {
  arrayOf, oneOf, shape, string,
} from 'prop-types'

import FormatFilterItem from './FormatFilterItem'
import TypeFilterItem from './TypeFilterItem'

function FilterItems({ items, type }) {
  const ItemComponent = type === 'types' ? TypeFilterItem : FormatFilterItem

  return (
    <div className={`filter-items filter-items--${type}`}>
      {items.map((item) => (
        <ItemComponent key={item.name} item={item} />
      ))}
    </div>
  )
}

FilterItems.propTypes = {
  items: arrayOf(
    shape({
      name: string.isRequired,
      count: string.isRequired,
      icon: string.isRequired,
      extensions: string,
      path: string.isRequired,
    })
  ).isRequired,
  type: oneOf(['types', 'formats']).isRequired,
}

FilterItems.displayName = 'FilterItems'

export default FilterItems
